import React from 'react';
import { getConfiguration } from '../data/utils/configuration';
import { loadLanguage } from '../data/utils/loadLanguage';
import Loader from "./Loader";
import OverlayWrapper from './OverlayWrapper';
import { getLabel } from '../data/labels';

export default function ResultsOverlay(props) {
    const conf = getConfiguration();
    const url = conf.ps?.rst.replace('{{lang}}', loadLanguage().toLowerCase());

    return (
        <OverlayWrapper id="xs-results-overlay">
            <div className="xs_resultsOverlay z-50 absolute top-0 left-0 right-0 bottom-0 grid grid-rows-[48px_1fr] bg-cs1">
                <div className="z-20 border-b border-b-cs7 bg-cs1">
                    <div className="h-full grid grid-cols-12 items-center">
                        <div className="col-start-1 col-end-3 justify-self-center inline-block" onClick={props.toggle}>
                            <i className="bi-x-lg font-medium text-lg text-cs-3"></i>
                        </div>
                        <div className="col-start-3 col-end-13 font-medium text-lg text-cs-3">{getLabel('general.outcomes')}</div>
                    </div>
                </div>
                <div className="relative">
                    <Loader />
                    <iframe title="xs-results-iframe" className="absolute top-0 left-0 right-0 bottom-0" width="100%" height="100%" src={url} />
                </div>
            </div>
        </OverlayWrapper>
    );
}
